import { Divider as AntdDivider } from 'antd'
import type { DividerProps } from 'antd'

export function Divider({ ...props }: DividerProps) {
  return <AntdDivider {...props} />
}
